module.exports = new __parcel__URL__("es_3.ad2f5d9f.png").toString();